"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Hash = _interopRequireDefault(require("./_Hash.js"));
var _ListCache = _interopRequireDefault(require("./_ListCache.js"));
var _Map = _interopRequireDefault(require("./_Map.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash.default(),
    'map': new (_Map.default || _ListCache.default)(),
    'string': new _Hash.default()
  };
}
var _default = exports.default = mapCacheClear;